import { h } from 'preact';
export const Send = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("line", { x1: "22", y1: "2", x2: "11", y2: "13" }),
        h("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })));
};
//# sourceMappingURL=send.js.map